<div class="mdc-notched-outline__leading"></div>
<div class="mdc-notched-outline__notch" [style.width]="_getNotchWidth()">
  <ng-content></ng-content>
</div>
<div class="mdc-notched-outline__trailing"></div>



// WEBPACK FOOTER //
// ../../../../../../src/material/form-field/directives/notched-outline.html